export default __webpack_public_path__ + "static/media/violet1.c34a476f.svg";